import React from 'react'
import { Typography } from '@mui/material'
import { flattenKeys, toCamelCase } from '../components/CustomTable/generateCells'

import { type Row, CustomColumnDef } from '../components/CustomTable/types'
import { type DataObjectList } from '../models/DataObject'

interface TaskMetadata {
  description?: string
  total?: number
  inserted?: number
  updated?: number
  errors?: number
  warnings?: number
}

interface TooltipContentProps {
  rowData: Row
  firstColumn: string
  list: DataObjectList<Row> | null | undefined
  onEditClick: ((row: Row) => void) | undefined
  rowMetaData: TaskMetadata | null | undefined
  shouldShowMetaDataTooltip: boolean
}

export function getTooltipContent ({ rowData, firstColumn, rowMetaData, shouldShowMetaDataTooltip }: TooltipContentProps): React.ReactNode {
  if (shouldShowMetaDataTooltip) {
    const { description, total, inserted, updated, errors, warnings } = rowMetaData || {}
    const allEmpty = [description, total, inserted, updated, errors, warnings].every(
      (value) => value === null || value === undefined || value === ''
    )
    if (allEmpty) {
      return <Typography variant="body2">No Metadata available.</Typography>
    }
    return (
      <>
        {description && <Typography variant="body2">Task: {description}</Typography>}
        {total != null && <Typography variant="body2">Total records processed: {total}</Typography>}
        {inserted != null && <Typography variant="body2">Records inserted: {inserted}</Typography>}
        {updated != null && <Typography variant="body2">Records updated: {updated}</Typography>}
        {errors != null && <Typography variant="body2">Errors encountered: {errors}</Typography>}
        {warnings != null && <Typography variant="body2">Warnings: {warnings}</Typography>}
      </>
    )
  } else {
    const flattenKeysRow = flattenKeys(rowData)
    const firstColumnConverted = toCamelCase(firstColumn)
    return flattenKeysRow?.[firstColumnConverted] ?? ''
  }
}
